import React, { Dispatch, SetStateAction } from "react";
import { useNavigate } from "react-router-dom";
import { UserCardState } from "../../interface/interface";
import { ReactComponent as RemoveSvg } from "./svg/remove.svg";
function UserCard({
  data,
  index,
  isopen,
  __setopen,
  remove,
}: {
  data: UserCardState | any;
  index: number;
  isopen: undefined | string;
  __setopen: Dispatch<SetStateAction<undefined | string>>;
  remove: (e: string) => void;
}) {
  const navigate = useNavigate();
  return (
    <div className="user-card">
      <div className="index">{data.usr_id}</div>
      <div className="id">{data.login_id}</div>
      <div className="email">{data.usr_email}</div>
      <div className="nickname">{data.login_nm}</div>
      <div className="project">{data.cnt_prjt}회</div>
      <div className="policy">{data.agr_adv ? "동의" : "미동의"}</div>
      <button
        className="detail"
        onClick={() => {
          navigate(`/user/detail`, { state: data });
        }}
      >
        상세보기
      </button>
      <button
        className="remove"
        onClick={() => {
          __setopen(data.usr_id);
        }}
      >
        <RemoveSvg />
      </button>
      <div
        className={`remove-section ${
          isopen === data.usr_id ? "remove-open" : ""
        }`}
      >
        <div className="title">회원을 삭제하시겠습니까?</div>
        <button
          onClick={() => {
            remove(data.usr_id);
            __setopen(undefined);
          }}
        >
          삭제하기
        </button>
      </div>
    </div>
  );
}

export default UserCard;
